import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy: React.FC = () => {
  const [year, setYear] = useState<number>(new Date().getFullYear());

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    setYear(currentYear);
  }, []);

  return (
    <div
      className="font-small mt-4"
      style={{
        maxWidth: "460px",
        color: "white",
        textAlign: "start",
        marginLeft: 68,
        marginBottom: 224,
      }}
    >
      <h2>Tietosuojakäytäntö</h2>
      <p>1.12.2024</p>
      <div>
        <h3>Johdanto</h3>
        Tässä tietosuojakäytännössä kuvataan, miten keräämme, käytämme ja
        suojaamme tietojasi, kun käytät junien kulkua seuraavaa sovellustamme.
        Yksityisyytesi on meille tärkeä, ja sitoudumme suojaamaan
        henkilötietojasi.
        <br />
        <br />
        <h3>Keräämämme tiedot </h3>
        Sovelluksemme mahdollistaa käyttäjien syöttää hakusanoja, jotta saamme
        reaaliaikaista tietoa Digitrafficin API rajapinnasta. Emme kerää
        käyttäjiltä mitään henkilökohtaisia tietoja, paitsi seuraavat:
        <br />- Jos päätät ottaa meihin yhteyttä, näemme sähköpostiosoitteesi
        viestin lähettäjänä. Tätä tietoa ei tallenneta tai käytetä muuhun
        tarkoitukseen, ja se on nähtävissä vain, jotta voimme vastata
        kysymyksiisi. Sähköpostiosoitettasi käytetään yhteydenpitoon
        kysymyksistäsi tai palautteestasi. Yhteyttä voit ottaa{" "}
        <strong>
          <Link
            to="/contact"
            className="nav-link"
            style={{ display: "inline", color: "lightblue" }}
          >
            täältä
          </Link>
        </strong>
        .
        <br />
        <br />
        <h3>Evästeet ja seurantatekniikat </h3>
        Sovelluksemme käyttää evästeitä ja vastaavia seurantatekniikoita
        käyttäjäkokemuksen parantamiseksi ja sivuston liikenteen
        analysoimiseksi. Käytämme Google Analyticsia kerätäksemme tietoja siitä,
        miten sovellustamme käytetään, mikä auttaa meitä parantamaan
        palveluitamme. Google voi käyttää kerättyjä tietoja
        kontekstualisoidakseen ja personoidakseen oman mainosverkostonsa
        mainoksia.
        <br />
        <br />
        <h3>Affiliate-linkit ja komissiot</h3>
        Sivustollamme on affiliate-linkkejä, joiden kautta tehdyt ostokset
        voivat tuottaa meille komission. Käyttäjien, jotka klikkaavat näitä
        linkkejä, tulee tietää, että voimme saada pienen komission, jos
        ostoprosessi tapahtuu linkin kautta. Tämä ei vaikuta hintoihin tai
        käyttäjien kokemukseen. Seuraamme mahdollisesti käyttäjien toimintaa
        evästeiden avulla, jotta voimme varmistaa komission saamisen.
        <br />
        <br />
        <h3>Kolmannen osapuolen palvelut </h3>
        Sovelluksemme on riippuvainen Digitrafficin API rajapinnasta, josta
        haemme reaaliaikaisia junatietoja. Käyttämällä sovellustamme tunnustat,
        että olemme riippuvaisia ulkoisista tietolähteistä, emmekä voi taata
        näiden tietojen tarkkuutta tai saatavuutta.
        <br />
        Tämä verkkosovellus on itsenäinen, eikä sillä ole yhteyttä tai
        yhteistyötä VR-Yhtymä Oy:n kanssa. Kaikki sovelluksessa esitetyt tiedot
        perustuvat Digitrafficin tarjoamiin avoimiin tietoihin, eikä VR ole
        osallisena niiden tuottamisessa tai ylläpidossa.
        <br />
        <br />
        <h3>Tietoturva </h3>
        Ryhdymme tarvittaviin toimenpiteisiin suojataksemme verkkosivustomme
        tietojen eheyttä ja suojaamme sivustoa luvattomalta käytöltä tai
        väärinkäytöltä. Huomaathan kuitenkin, että mikään internetin kautta
        tapahtuva tiedonsiirto tai sähköinen tallennusmenetelmä ei ole täysin
        riskitön, emmekä voi taata ehdotonta turvallisuutta.
        <br />
        <br />
        <h3>Vastuuvapauslauseke </h3>
        Sovelluksemme tarjoaa junien kulkua ja aikataulutietoja, jotka haetaan
        Digitrafficin API rajapinnasta. Emme voi taata, että kaikki tiedot ovat
        tarkkoja tai ajantasaisia. Datan saannin puutteet tai virheet voivat
        johtaa virheellisiin juna- ja aikataulutietoihin sovelluksessa.
        Käyttäjien on suositeltavaa tarkistaa aikataulut ja kulkuajat
        virallisista lähteistä ennen matkojaan. Emme ota vastuuta mahdollisista
        myöhästymisistä tai muista ongelmista, jotka johtuvat virheellisistä
        tiedoista sovelluksessa.
        <br />
        <br />
        <h3>Sovelluksen muutokset ja käytettävyys</h3> Pidätämme oikeuden tehdä
        sovellukseen muutoksia, kuten päivityksiä, ominaisuuksien lisäyksiä tai
        poistamisia, käyttöehtojen päivittämiseksi tai palvelun parantamiseksi.
        Lisäksi varaamme oikeuden poistaa sovellus julkisesta verkosta, jos
        siihen on liiketoiminnallisia, teknisiä tai tietoturvaan liittyviä
        syitä. Pyrimme ilmoittamaan käyttäjille etukäteen sovelluksen
        merkittävistä muutoksista tai poistosta, mutta emme voi taata
        ennakkoilmoitusta kaikissa tilanteissa.
        <br />
        <br />
        <h3>Muutokset tietosuojakäytäntöön </h3>
        Saatamme päivittää tätä tietosuojakäytäntöä aika ajoin. Ilmoitamme
        sinulle kaikista muutoksista julkaisemalla uuden tietosuojakäytännön
        tällä sivulla. Suosittelemme, että tarkistat tätä tietosuojakäytäntöä
        säännöllisesti muutosten varalta.
      </div>
      <br />
      <br />
      <nav
        style={{
          padding: "4px",
          backgroundColor: "#1e5a72",
          color: "lightgray",
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
          fontSize: 11,
          zIndex: 2,
        }}
      >
        <div
          className="d-flex justify-content-center"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            maxWidth: "800px",
            margin: "0 auto",
            gap: "15px",
          }}
        >
          <Link to="/set-train-number" className="nav-link">
            minunjunani.fi
          </Link>
          <Link to="/privacy-policy" className="nav-link">
            Tietosuojakäytäntö
          </Link>
          <Link to="/cookies" className="nav-link">
            Evästeet
          </Link>
        </div>
        <div className="">&copy; {year} minunjunani.fi</div>
        <a
          href="https://www.digitraffic.fi/kayttoehdot/"
          target="_blank"
          style={{ color: "darkgray" }}
        >
          Liikennetietojen lähde Fintraffic / digitraffic.fi, lisenssi CC 4.0 BY
        </a>
      </nav>
    </div>
  );
};

export default PrivacyPolicy;
